import React from 'react';

export interface MensajeIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const MensajeIcon: React.FC<MensajeIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.334 6.72c0-1.1-.9-2-2-2h-16c-1.1 0-2 .9-2 2m20 0v12c0 1.1-.9 2-2 2h-16c-1.1 0-2-.9-2-2v-12m20 0-10 7-10-7"/>
    </svg>
  );
};

export default MensajeIcon;
